import {initialize} from 'react-ga'
const TRACKING_ID = 'UA-81478433-1'

export const initGoogleAnalytics = () => {
    initialize(TRACKING_ID)
}
